{
  "version": 1,
  "meta": {
    "id": "phase-shift",
    "name": "Phase Shift",
    "description": "Gravity flips and the world turns upside down",
    "author": "TriggernometryDash",
    "difficulty": "normal",
    "version": 1,
    "parTime": 55000,
    "optimalInputs": 35,
    "tags": ["gravity", "real"]
  },
  "settings": {
    "initialMode": "real",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#ff00ff",
    "accentColor": "#00ffff",
    "backgroundColor": "#0a0a1a",
    "gridIntensity": 0.7,
    "music": {
      "bpm": 120,
      "key": "Am",
      "style": "synthwave",
      "song": "deep-current",
      "layers": ["bass", "drums"]
    },
    "fog": { "near": 50, "far": 200, "color": "#0a0a1a" }
  },
  "segments": [
    {
      "id": "seg-01-warmup",
      "mode": "real",
      "length": 1000,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 300, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 550, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 580, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 800, "across": 0, "up": 0 }, "size": { "width": 30, "height": 50 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-02-pre-flip",
      "mode": "real",
      "length": 800,
      "speed": 1.1,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": { "function": "constant", "offset": 300 }
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 200, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 450, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 650, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-03-flipped",
      "mode": "real",
      "length": 1200,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": { "function": "constant", "offset": 300 }
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 300, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 500, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 750, "across": 0, "up": 0 }, "size": { "width": 30, "height": 45 } },
        { "type": "spike", "position": { "along": 1000, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-04-restore",
      "mode": "real",
      "length": 1200,
      "speed": 1.1,
      "terrain": {
        "type": "function",
        "floor": { "function": "sin", "amplitude": 25, "frequency": 0.01, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 200, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 400, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 430, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 700, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 950, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 980, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-05-finale",
      "mode": "real",
      "length": 1300,
      "speed": 1.2,
      "terrain": {
        "type": "function",
        "floor": { "function": "cos", "amplitude": 20, "frequency": 0.015, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 150, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 350, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 380, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 600, "across": 0, "up": 0 }, "size": { "width": 30, "height": 55 } },
        { "type": "spike", "position": { "along": 800, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 830, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 860, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1100, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    }
  ],
  "triggers": [
    { "id": "trg-01", "type": "text", "position": 50, "duration": 2000, "easing": "sine-in-out", "params": { "text": "Things aren't always what they seem...", "style": "floating" } },
    { "id": "trg-02", "type": "music", "position": 800, "duration": 0, "easing": "linear", "params": { "action": "add_layer", "layer": "pad" } },
    { "id": "trg-03", "type": "text", "position": 1700, "duration": 2000, "easing": "sine-in-out", "params": { "text": "Reality shifts...", "style": "floating" } },
    { "id": "trg-04", "type": "gravity", "position": 1800, "duration": 0, "easing": "linear", "params": { "direction": "up", "strength": 1.0 } },
    { "id": "trg-05", "type": "color", "position": 1800, "duration": 500, "easing": "sine-in-out", "params": { "baseColor": "#ff44ff", "accentColor": "#44ffff" } },
    { "id": "trg-06", "type": "camera", "position": 1800, "duration": 0, "easing": "linear", "params": { "action": "shake", "intensity": 12 } },
    { "id": "trg-07", "type": "text", "position": 2900, "duration": 1500, "easing": "sine-in-out", "params": { "text": "Back to normal", "style": "floating" } },
    { "id": "trg-08", "type": "gravity", "position": 3000, "duration": 0, "easing": "linear", "params": { "direction": "down", "strength": 1.0 } },
    { "id": "trg-09", "type": "color", "position": 3000, "duration": 500, "easing": "sine-in-out", "params": { "baseColor": "#ff00ff", "accentColor": "#00ffff" } },
    { "id": "trg-10", "type": "music", "position": 3500, "duration": 0, "easing": "linear", "params": { "action": "add_layer", "layer": "lead" } },
    { "id": "trg-11", "type": "speed", "position": 4200, "duration": 500, "easing": "ease-in", "params": { "speed": 1.2 } }
  ],
  "collectibles": [
    { "type": "star", "position": { "along": 900, "across": 0, "up": 160 }, "index": 0 },
    { "type": "star", "position": { "along": 2500, "across": 0, "up": 250 }, "index": 1 },
    { "type": "star", "position": { "along": 4500, "across": 0, "up": 160 }, "index": 2 }
  ]
}
